import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarussel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCarussel"><Path fillRule="evenodd" clipRule="evenodd" d="M5.75 3H18.25V5H22V19H18.25V21H5.75V19H2V5H5.75V3ZM18.25 6.5V17.5H20.5V6.5H18.25ZM5.75 17.5V6.5H3.5V17.5H5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCarussel;
